import { toast } from "../../toast/toast";
import React from "react";
import ReactDOM from "react-dom";
import { Lab } from "../../../../backend/src/types";
import { useUser } from "../../contexts/UserContext";
import { addLab, updateLab } from "../../fetch/labRequest";
import styles from "../../styles/modules/AdminPage.module.css";
import RequiredMark from "../RequiredMark";

interface LabPopupProps {
  targetLab: Lab | null;
  onClose: () => void;
  onLoading: (start: boolean) => void;
  updateLabList: (updatedLab: Lab) => void;
}

const LabPopup: React.FC<LabPopupProps> = ({
  targetLab,
  onClose,
  onLoading,
  updateLabList,
}) => {
  const isEdit = targetLab !== null;
  const [name, setName] = React.useState<string>(
    isEdit && targetLab ? targetLab.name : ""
  );
  const { user } = useUser();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const trimmedName = name.trim();
    if (!trimmedName) {
      toast.error("研究室名を入力してください。");
      return;
    }

    onLoading(true);
    const data: Lab = {
      id: isEdit ? targetLab!.id : 0,
      name: trimmedName,
      tenant_id: user?.tenant_id ?? 0,
    };

    isEdit ? await handleUpdateLab(data) : await handleAddLab(data);

    onLoading(false);
    onClose();
  }

  async function handleAddLab(lab: Lab) {
    const addedLab = await addLab(lab);
    if (addedLab) {
      updateLabList(addedLab);
      toast.success("研究室を登録しました。");
    }
  }
  async function handleUpdateLab(lab: Lab) {
    const updatedLab = await updateLab(lab);
    if (updatedLab) {
      updateLabList(updatedLab);
      toast.success("研究室情報を更新しました。");
    }
  }

  const popupContent = (
    <div className={styles["popup-background"]} onClick={onClose}>
      <div
        className={styles["popup-section"]}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>{isEdit ? "研究室情報の編集" : "研究室の登録"}</h3>
        <form onSubmit={handleSubmit}>
          <label>
            <span>
              研究室名
              <RequiredMark />
            </span>
            <input
              type="text"
              placeholder="例：〇〇研究室"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <div className={styles["button-row"]}>
            <button type="submit" className={styles["ok-button"]}>{isEdit ? "更新" : "登録"}</button>
            <button type="button" onClick={onClose}>
              キャンセル
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    popupContent,
    document.getElementById("popup-root")!
  );
};

export default LabPopup;
